
$body.on("click","[data-cats-wrapper] [data-cat]",function(e){

    /**
     * <data-cats-wrapper>
     *      <data-cat>      //toggler
     *      <data-cats>     //éléments avec des cats
     *  </>
     */


    e.preventDefault();
    e.stopPropagation();


    let $wrapper=$(this).closest("[data-cats-wrapper]");
    let $a=$(this);
    let $all=$wrapper.find("[data-cat]");
    let $targets=$wrapper.find("[data-cats]");
    let $trait=$wrapper.find(".trait");

    $(document).scrollTop($wrapper.offset().top-50);
    setTimeout(function () {
        AOS.refresh();
    },1000);

    if($a.is(".active")){
        $a.removeClass("active");
    }else{
        $all.removeClass("active");
        $a.addClass("active");
    }
    let $active=$all.filter(".active");
    let catUidToShow=$active.attr("data-cat");
    if(!$active.length){
        $wrapper.removeClass("one-active");
        showAll();
    }else{
        $wrapper.addClass("one-active");
        show(catUidToShow);
        traitGoTo($a);
    }


    function showAll(){
        $targets.removeClass("inactive");

    }
    function show(id){
        $targets.addClass("inactive");
        $targets.filter("[data-cats*='"+id+"']").removeClass("inactive");
    }

    function traitGoTo($el){
        TweenMax.to($trait,0.5,{y:$el.position().top})
    }
});


// WEBPACK FOOTER //
// ./fk.app/_src/components/data-cats.js